import React, { useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import AiDraftPopover from './Popover'
import type { AiDraftPopoverProps } from './types'

const AiDraftPopoverWrapper: React.FC<AiDraftPopoverProps> = (props) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false
          }
        }
      })
  )

  return (
    <QueryClientProvider client={queryClient}>
      <AiDraftPopover {...props} />
    </QueryClientProvider>
  )
}

export default AiDraftPopoverWrapper
